'use strict';
import {isPostalCode, tryEqual} from './module.js';

//-----------------------------------
// 郵便番号
//-----------------------------------
if (
  document.querySelector('input[name="postalcode1"]') &&
  document.querySelector('input[name="postalcode2"]')
) {
  document.querySelector('input[name="postalcode1"]').addEventListener('input', (event) => {
    const $this = event.target;
    if ($this.value.length == 3) {
      setTimeout(function () {
        document.querySelector('input[name="postalcode2"]').focus();
      }, 500);
    }
  });
  document.querySelector('input[name="postalcode2"]').addEventListener('input', (event) => {
    if (
      isPostalCode(
        document.querySelector('input[name="postalcode1"]').value +
          document.querySelector('input[name="postalcode2"]').value
      )
    ) {
      setTimeout(function () {
        document.querySelector('input[name="address"]').focus();
      }, 500);
    }
  });
}

/**
 * 送信
 *
 * */
const $postFormBtn = document.getElementById('postFormBtn') || undefined;
const $postForm = document.getElementById('postForm') || undefined;
if ($postFormBtn) {
  $postFormBtn.classList.remove('disabled');
}
if ($postForm) {
  document.getElementById('postForm').addEventListener('submit', (event) => {
    event.preventDefault();
    // ボタンを非活性にする
    $postFormBtn.classList.add('disabled');
    $postFormBtn.blur();

    try {
      // メールアドレス一致のチェック
      tryEqual('email', 'email_confirm', 'Please check your input at mail address.');
    } catch (Exception) {
      $postFormBtn.classList.remove('disabled');
      return false;
    }
    event.target.submit();
    return true;
  });
}

const $complateFormBtn = document.getElementById('complateFormBtn') || undefined;
const $complateForm = document.getElementById('complateForm') || undefined;
if ($complateFormBtn) {
  $complateFormBtn.classList.remove('disabled');
}
if ($complateForm) {
  document.getElementById('complateForm').addEventListener('submit', (event) => {
    console.log(1);
    event.preventDefault();
    // ボタンを非活性にする
    $complateFormBtn.classList.add('disabled');
    $complateFormBtn.blur();
    event.target.submit();
    return true;
  });
}
